export default __webpack_public_path__ + "static/media/renuma-plus-01.ee08d2da.webp";